import { Usuario } from "@/shared/dtos/usuario";
import { departamento } from "./departamento";

export class UsuarioAllDto extends Usuario {
  public departamento!: departamento;
}
